import React from 'react';

interface State { hasError: boolean; error: Error | null }

export default class PracticeErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-[1200px] mx-auto px-6 py-7 pb-20 min-h-[calc(100vh-var(--nav-h))]">
          <div className="px-6 py-12 text-center text-subdued text-sm">
            <p>Something went wrong loading your practice data.</p>
            <p className="text-xs text-faint mt-2">
              {this.state.error?.message || 'Unknown error'}
            </p>
            <button
              className="mt-4 px-[18px] py-[7px] text-sm font-semibold bg-[var(--color-accent)] text-white border-none rounded-md cursor-pointer transition-[background,transform] duration-150 hover:bg-[var(--color-accent-hover)] hover:-translate-y-0.5"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
